
export const compxLinks = {

  mvar: "https://www.ngdc.noaa.gov/geomag/calculators/magcalc.shtml",
  pilotsHndbk: "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/phak",
  flyHndbk: "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/airplane_handbook",
  instHndbk: "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/instrument_procedures_handbook",
};